import { OfbizForm, OfbizList } from "@urbannex/ofbiz-forms";
import { ActionState, ConfigOptions, getColumnFieldTitles, getFields } from "@urbannex/view-containers";
import { PART_FORMS } from "../../forms";

export const ORDER_FORMS = [

]

export const orderoptions:ConfigOptions = {
    name: "Orders",
    title: "Customer Orders",
    defaultAction:ActionState.LIST,
    listForm:new OfbizList({
        listFormName:"CustomerOrders",
        listFormLocation:"component://kwikstore/widget/PartyForms.xml",
        columnFields:getFields("CustomerOrders",PART_FORMS),
        columnFieldTitles:getColumnFieldTitles("CustomerOrders",PART_FORMS),
        emptyListMessage:"No Orders Found For This Party.",
        remoteFormData:{
            formData: {
                formName: "CustomerOrders",
                formLocation: "component://kwikstore/widget/PartyForms.xml",
                listType: "grid",
                entityName: "",
                viewIndex: 0
            },
            parameters:{"partyId":""}
        }
    }),
    findForm: new OfbizForm,
    addForm: new OfbizForm,
    actions: [],
    settings: []
}